import { ResponsePanelWebComponent } from './component/ResponsePanelWebComponent';
import { WEB_COMPONENT_RESPONSE_PANEL } from '../../webcomponents.constants';

export { ResponsePanelWebComponent };

window.customElements.define(WEB_COMPONENT_RESPONSE_PANEL, ResponsePanelWebComponent);
